import { render, staticRenderFns } from "./DUDCategoriesVV.vue?vue&type=template&id=6baefc60&scoped=true&"
import script from "./DUDCategoriesVV.vue?vue&type=script&lang=ts&"
export * from "./DUDCategoriesVV.vue?vue&type=script&lang=ts&"
import style0 from "./DUDCategoriesVV.vue?vue&type=style&index=0&id=6baefc60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baefc60",
  null
  
)

export default component.exports